const ordersModule = {
    namespaced: true,
    state: {
        reportFilters: {
            startDate: new Date().toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
            restaurantId: 'all',
            orderType: 'all',
            paymentMethod: 'all',
        },
        listFilters: {
            search: '',
            status: 'all',
            page: 1,
            restaurantId: 'all',
        },
    },
    mutations: {
        SET_REPORT_FILTERS(state, filters) {
            state.reportFilters = { ...state.reportFilters, ...filters };
        },
        SET_LIST_FILTERS(state, filters) {
            state.listFilters = { ...state.listFilters, ...filters };
        },
        RESET_FILTERS(state) {
            state.listFilters = {
                search: '',
                status: 'all',
                page: 1,
                restaurantId: 'all',
            };
        }
    },
    actions: {
        updateReportFilters({ commit }, filters) {
            commit('SET_REPORT_FILTERS', filters);
        },
        updateListFilters({ commit }, filters) {
            commit('SET_LIST_FILTERS', filters);
        },
    },
    getters: {
        reportFilters: (state) => state.reportFilters,
        listFilters: (state) => state.listFilters,
    },
};
export default ordersModule;
